/* eslint semi:0 */
import { getIsMobile, getIsTablet } from '../../jsCore/utils/ua'
import { queryString as qs } from '../../jsCore/utils/window'
import socialButtonsConf from '../../jsCore/organizedByType/config/socialButtonsConfig'
import { getReactionsList } from '../../jsCore/application/pageDataObject'
import safeLocalStorage from '../../jsCore/providers/safeLocalStorageProvider'
import { getMockReactions, getClientVotes as getClientVotesMock } from './mock/socialBarDataMock'

const FEATURE_FLAGS = {
  reactionsMock: qs.reactionsMock,
  reactionsCampaignMock: qs.reactionsCampaignMock,
  votesMock: qs.votesMock,
  reactionsNoCachedVotes: qs.reactionsNoCachedVotes,
}
const CLIENT_VOTES_KEY = 'CLIENT_VOTES_KEY'

function getVotesFromLocalStorage() {
  if (FEATURE_FLAGS.reactionsNoCachedVotes) {
    return {}
  }
  return safeLocalStorage.get(CLIENT_VOTES_KEY, {})
}

export function cacheVote({ postId, reactionId }) {
  const curr = safeLocalStorage.get(CLIENT_VOTES_KEY, {})
  curr[postId] = reactionId
  safeLocalStorage.set(CLIENT_VOTES_KEY, curr)
}

export function getReactions() {
  if (FEATURE_FLAGS.reactionsMock) {
    return getMockReactions({ doesIncludeCampaign: FEATURE_FLAGS.reactionsCampaignMock })
  }
  return getReactionsList()
}

export function getClientVotes() {
  if (FEATURE_FLAGS.votesMock) {
    return getClientVotesMock()
  }
  return getVotesFromLocalStorage()
}

export function setUserVote({ postId, reactionId }) {
  const currVotesData = getVotesFromLocalStorage()
  const newVotesData = { ...currVotesData, [postId]: reactionId }
  safeLocalStorage.set(CLIENT_VOTES_KEY, newVotesData)
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/reactions/socialBarDataSource.js